"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SVGComponent = (props) => (React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", Object.assign({ fill: "none" }, props),
        React.createElement("path", { d: "M6.38175 7.8072C5.82878 6.69982 4.58685 6.1181 3.38212 6.40217C2.17739 6.68624 1.32617 7.76151 1.32617 8.99928C1.32617 10.2371 2.17739 11.3123 3.38212 11.5964C4.58685 11.8805 5.82878 11.2987 6.38175 10.1914" }),
        React.createElement("path", { d: "M14.0045 6.66522C15.2012 6.66815 16.2542 5.87591 16.5831 4.72528C16.9119 3.57465 16.4365 2.3456 15.419 1.71573C14.4015 1.08586 13.0894 1.20844 12.2062 2.01588C11.3229 2.82331 11.0834 4.11915 11.6197 5.18896" }),
        React.createElement("path", { d: "M11.6194 12.8104C11.0861 13.8776 11.3261 15.1691 12.207 15.9735C13.0879 16.778 14.3958 16.9 15.4103 16.2723C16.4248 15.6446 16.8994 14.4197 16.5726 13.2723C16.2459 12.125 15.1972 11.3339 14.0042 11.3348" }),
        React.createElement("path", { d: "M14.003 6.66522C12.9926 6.6643 12.0695 6.09285 11.6181 5.18896L6.38086 7.80727C6.75978 8.55705 6.75978 9.4423 6.38086 10.1921L11.6181 12.8111C12.0695 11.9072 12.9926 11.3357 14.003 11.3348" }))));
exports.default = SVGComponent;
//# sourceMappingURL=shareposticon.js.map